import { render, staticRenderFns } from "./EventCommentInput.vue?vue&type=template&id=6e35d560&scoped=true&"
import script from "./EventCommentInput.vue?vue&type=script&lang=js&"
export * from "./EventCommentInput.vue?vue&type=script&lang=js&"
import style0 from "./EventCommentInput.vue?vue&type=style&index=0&id=6e35d560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e35d560",
  null
  
)

export default component.exports